<div class="">
  <div class="page-content">
    <div class="row">
      <div class="col-6 ps-0">
        <h2 class="heading1 d-none d-sm-block">{{this.getFormTitle}}</h2>
        <h2 class="heading1 d-block d-sm-none">{{this.getFormSubTitle}}</h2>
      </div>
      <div class="col-6 text-end">
        <button *ngIf="canAdd" #buttonNewRow mat-raised-button (click)="onClickOfGenericNewButton()" class="primary-btn">
          {{ 'Create New' }}
        </button>
      </div>
    </div>


    <div class="row mt-4 d-none d-sm-flex">
      <div class="col-md-6">
        <h3 class="heading2">{{this.getFormSubTitle}}</h3>
      </div>
    </div>

    <div class="row">
      <div class="col-md-12 tabledesign">
        <app-chip [filterItems]='selectedFilters' (removeFilter)="onRemoveChip($event.index,$event.data)"></app-chip>
        <table mat-table [dataSource]="this.getListViewDataSource" *ngIf="this.getFormSubTitle!='Pick Lists'">
          <!-- this.getListViewDataSource -->

          <!-- S.No. Column -->
          <ng-container matColumnDef="docNum">
            <th mat-header-cell *matHeaderCellDef class="text-center">
              <!-- <mat-checkbox class="ps-0"></mat-checkbox> -->
              {{'Language.DocumentNumberText' | translate }}
            
              <i-feather class="t-icon" name="more-vertical" [matMenuTriggerFor]="menu1"></i-feather>
              <mat-menu #menu1="matMenu" class="filtertrigger" xPosition="after">
                <app-filter [shortColumn]="'docNum'" [colType]="'numerics'" 
                [labelType]="'Language.DocumentNumberText' | translate" [isActive]="this.active"
                  (FilterColumn)="onClickOfGenericFilterButtonForRangeNumber($event.column, $event.formid, $event.toid,$event.label)"
                  (sortFilter)="this.onClickOfGenericColumnSort('docNum',this.active)"></app-filter>
              </mat-menu>

            </th>
            <td mat-cell *matCellDef="let row;let i=index;" class="text-center">
              <!-- <mat-checkbox class="ps-0"></mat-checkbox> -->
              <!-- {{i+1}} -->
              <span class="">{{row.docNum}}</span>
            </td>
          </ng-container>

          <!-- Group Name Column -->
          <ng-container matColumnDef="cardCode" *ngIf="this.getFormSubTitle!='Purchase Request'">
            <th mat-header-cell *matHeaderCellDef> {{'Language.CardCodeText' | translate }} 
              <i-feather class="t-icon" name="more-vertical" [matMenuTriggerFor]="menu1"></i-feather>
              <mat-menu #menu1="matMenu" class="filtertrigger" xPosition="after" >
                <app-filter [shortColumn]="'cardCode'" [colType]="'alphabets'" 
                [labelType]="'Language.CardCodeText' | translate" [isActive]="this.active"
                  (FilterColumn)="onClickOfGenericFilterButtonForRangeString($event.column, $event.formid, $event.toid,$event.label)"
                  (sortFilter)="this.onClickOfGenericColumnSort('cardCode',this.active)"></app-filter>
              </mat-menu>
            
            </th>
            <td mat-cell *matCellDef="let row">
              {{row.cardCode}}
            </td>
          </ng-container>
          <ng-container matColumnDef="cardCode" *ngIf="this.getFormSubTitle=='Purchase Request'">
            <th mat-header-cell *matHeaderCellDef> {{'Language.RequesterCodeText' | translate }} 
              <i-feather class="t-icon" name="more-vertical" [matMenuTriggerFor]="menu1"></i-feather>
              <mat-menu #menu1="matMenu" class="filtertrigger" xPosition="after" >
                <app-filter [shortColumn]="'requester'" [colType]="'alphabets'" 
                [labelType]="'Language.CardCodeText' | translate" [isActive]="this.active"
                  (FilterColumn)="onClickOfGenericFilterButtonForRangeString($event.column, $event.formid, $event.toid,$event.label)"
                  (sortFilter)="this.onClickOfGenericColumnSort('requester',this.active)"></app-filter>
              </mat-menu>
            
            </th>
            <td mat-cell *matCellDef="let row">
              {{row.requester}}
            </td>
          </ng-container>
          

          <ng-container matColumnDef="cardName" *ngIf="this.getFormSubTitle!='Purchase Request'">
            <th mat-header-cell *matHeaderCellDef> {{'Language.CardNameText' | translate }} 
              <i-feather class="t-icon" name="more-vertical" [matMenuTriggerFor]="menu1"></i-feather>
              <mat-menu #menu1="matMenu" class="filtertrigger" xPosition="after">
                <app-filter [shortColumn]="'cardName'" [colType]="'alphabets'" 
                [labelType]="'Language.CardNameText' | translate" [isActive]="this.active"
                  (FilterColumn)="onClickOfGenericFilterButtonForRangeString($event.column, $event.formid, $event.toid,$event.label)"
                  (sortFilter)="this.onClickOfGenericColumnSort('cardName',this.active)"></app-filter>
              </mat-menu>
            </th>
            <td mat-cell *matCellDef="let row">
              {{row.cardName}}
            </td>
          </ng-container>
          <ng-container matColumnDef="cardName" *ngIf="this.getFormSubTitle=='Purchase Request'">
            <th mat-header-cell *matHeaderCellDef> {{'Language.RequesterNameText' | translate }} 
              <i-feather class="t-icon" name="more-vertical" [matMenuTriggerFor]="menu1"></i-feather>
              <mat-menu #menu1="matMenu" class="filtertrigger" xPosition="after" >
                <app-filter [shortColumn]="'requesterName'" [colType]="'alphabets'" 
                [labelType]="'Language.RequesterNameText' | translate" [isActive]="this.active"
                  (FilterColumn)="onClickOfGenericFilterButtonForRangeString($event.column, $event.formid, $event.toid,$event.label)"
                  (sortFilter)="this.onClickOfGenericColumnSort('requesterName',this.active)"></app-filter>
              </mat-menu>
            
            </th>
            <td mat-cell *matCellDef="let row">
              {{row.requesterName}}
            </td>
          </ng-container>

          <!-- Control Account Column -->
          <ng-container matColumnDef="branchName">
            <th mat-header-cell *matHeaderCellDef>  {{'Language.BranchNameText' | translate }}
              <i-feather class="t-icon" name="more-vertical" [matMenuTriggerFor]="menu1"></i-feather>
              <mat-menu #menu1="matMenu" class="filtertrigger" xPosition="after">
                <app-filter [shortColumn]="'branchName'" [colType]="'alphabets'" 
                [labelType]="'Language.BranchNameText' | translate" [isActive]="this.active"
                  (FilterColumn)="onClickOfGenericFilterButtonForRangeString($event.column, $event.formid, $event.toid,$event.label)"
                  (sortFilter)="this.onClickOfGenericColumnSort('branchName',this.active)"></app-filter>
              </mat-menu>
            </th>
            <td mat-cell *matCellDef="let row">
              {{row.branchName}}
            </td>
          </ng-container>

          <!-- Control Account Column -->
          <ng-container matColumnDef="salesPersonCodeName"  >
            <th mat-header-cell *matHeaderCellDef [ngStyle]="getFormSubTitle == 'Purchase Request' ? {'display': 'none'} : {}"> {{'Language.SalesPersonNameText' | translate }}
              <i-feather class="t-icon" name="more-vertical" [matMenuTriggerFor]="menu1"></i-feather>
              <mat-menu #menu1="matMenu" class="filtertrigger" xPosition="after">
                <app-filter [shortColumn]="'salesPersonCodeName'" [colType]="'alphabets'" 
                [labelType]="'Language.SalesPersonNameText' | translate" [isActive]="this.active"
                  (FilterColumn)="onClickOfGenericFilterButtonForRangeString($event.column, $event.formid, $event.toid,$event.label)"
                  (sortFilter)="this.onClickOfGenericColumnSort('salesPersonCodeName',this.active)"></app-filter>
              </mat-menu>
            </th>
            <td mat-cell *matCellDef="let row" [ngStyle]="getFormSubTitle == 'Purchase Request' ? {'display': 'none'} : {}">
              {{row.salesPersonCodeName}}
            </td>
          </ng-container>
          <ng-container matColumnDef="docDate">
            <th mat-header-cell *matHeaderCellDef> {{'Language.DocumentDateText' | translate }}
              <i-feather class="t-icon" name="more-vertical" [matMenuTriggerFor]="menu1"></i-feather>
              <mat-menu #menu1="matMenu" class="filtertrigger" xPosition="after">
                <app-filter [colType]="'DateType'" [shortColumn]="'docDate'"
                  [labelType]="'Language.DocumentDateText' | translate" [isActive]="this.active"
                  (FilterColumn)="onClickOfGenericFilterButtonForDate($event.column, $event.formid, $event.toid,$event.label)"
                  (sortFilter)="this.onClickOfGenericColumnSort('docDate',this.active)"></app-filter>
              </mat-menu>
            </th>
            <td mat-cell *matCellDef="let row">
              {{row.docDate | date : "dd-MM-yyyy"}}
            </td>
          </ng-container>
          <ng-container matColumnDef="documentStatusName">
            <th mat-header-cell *matHeaderCellDef>  {{'Language.StatusText' | translate }}
              <i-feather class="t-icon" name="more-vertical" [matMenuTriggerFor]="menu1"></i-feather>
              <mat-menu #menu1="matMenu" class="filtertrigger" xPosition="after">
                <app-filter [shortColumn]="'documentStatusName'" [colType]="'alphabets'" 
                [labelType]="'Language.StatusText' | translate" [isActive]="this.active"
                  (FilterColumn)="onClickOfGenericFilterButtonForRangeString($event.column, $event.formid, $event.toid,$event.label)"
                  (sortFilter)="this.onClickOfGenericColumnSort('documentStatusName',this.active)"></app-filter>
              </mat-menu>
            </th>
            <td mat-cell *matCellDef="let row">
              {{row.documentStatusName}}
            </td>
          </ng-container>

          <!-- Star Column -->
          <ng-container matColumnDef="action">
            <th mat-header-cell *matHeaderCellDef class="text-center">{{'Language.ActionText' | translate }}</th>
            <td mat-cell *matCellDef="let row" class="text-center">
              <i-feather class="t-icon pointer" *ngIf="canEdit" name="edit-2" (click)="onClickOfGenericEditButton(row.docEntry)">
              </i-feather>
              <i-feather class="t-icon pointer" *ngIf="!canEdit && isActiveMenu" name="eye" (click)="onClickOfGenericEditButton(row.docEntry)">
              </i-feather>
              <i-feather class="t-icon pointer ms-2" name="printer" [matMenuTriggerFor]="menu"></i-feather>
               <mat-menu #menu="matMenu">
                <button mat-menu-item *ngFor="let item of printFormats" (click)="printDocument(row.docEntry, item.formatCode)">
                  <span>{{item.formatName}}</span>
                </button>
              </mat-menu>
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="this.getDisplayedColumnsNamesList"></tr>
          <tr mat-row *matRowDef="let row; columns: this.getDisplayedColumnsNamesList;"></tr>
        </table>
        <table mat-table [dataSource]="this.getListViewDataSource" *ngIf="this.getFormSubTitle=='Pick Lists'">
          <!-- this.getListViewDataSource -->

          <!-- S.No. Column -->
          <ng-container matColumnDef="absoluteentry">
            <th mat-header-cell *matHeaderCellDef class="text-center">
              <!-- <mat-checkbox class="ps-0"></mat-checkbox> -->
              {{'Language.DocumentNumberText' | translate }}
            
              <i-feather class="t-icon" name="more-vertical" [matMenuTriggerFor]="menu1"></i-feather>
              <mat-menu #menu1="matMenu" class="filtertrigger" xPosition="after">
                <app-filter [shortColumn]="'absoluteentry'" [colType]="'numerics'" 
                [labelType]="'Language.DocumentNumberText' | translate" [isActive]="this.active"
                  (FilterColumn)="onClickOfGenericFilterButtonForRangeNumber($event.column, $event.formid, $event.toid,$event.label)"
                  (sortFilter)="this.onClickOfGenericColumnSort('absoluteentry',this.active)"></app-filter>
              </mat-menu>

            </th>
            <td mat-cell *matCellDef="let row;let i=index;" class="text-center">
              <!-- <mat-checkbox class="ps-0"></mat-checkbox> -->
              <!-- {{i+1}} -->
              <span class="">{{row.absoluteentry}}</span>
            </td>
          </ng-container>

          <!-- Group Name Column -->
          <ng-container matColumnDef="orderEntry">
            <th mat-header-cell *matHeaderCellDef> {{'Language.OrderNoText' | translate }} 
              <i-feather class="t-icon" name="more-vertical" [matMenuTriggerFor]="menu1"></i-feather>
              <mat-menu #menu1="matMenu" class="filtertrigger" xPosition="after">
                <app-filter [shortColumn]="'orderEntry'" [colType]="'numerics'" 
                [labelType]="'Language.OrderNoText' | translate" [isActive]="this.active"
                  (FilterColumn)="onClickOfGenericFilterButtonForRangeNumber($event.column, $event.formid, $event.toid,$event.label)"
                  (sortFilter)="this.onClickOfGenericColumnSort('orderEntry',this.active)"></app-filter>
              </mat-menu>
            </th>
            <td mat-cell *matCellDef="let row">
              {{row.orderEntry}}
            </td>
          </ng-container>

          <ng-container matColumnDef="pickDate">
            <th mat-header-cell *matHeaderCellDef> {{'Language.PickDateText' | translate }} 
              <i-feather class="t-icon" name="more-vertical" [matMenuTriggerFor]="menu1"></i-feather>
              <mat-menu #menu1="matMenu" class="filtertrigger" xPosition="after">
                <app-filter [shortColumn]="'pickDate'" [colType]="'DateType'" 
                [labelType]="'Language.PickDateText' | translate" [isActive]="this.active"
                (FilterColumn)="onClickOfGenericFilterButtonForDate($event.column, $event.formid, $event.toid,$event.label)"
                (sortFilter)="this.onClickOfGenericColumnSort('pickDate',this.active)"></app-filter>
              </mat-menu>
            </th>
            <td mat-cell *matCellDef="let row">
              {{row.pickDate | date:'dd-MM-yyyy'}}
            </td>
          </ng-container>

          <!-- Control Account Column -->
          <ng-container matColumnDef="remarks">
            <th mat-header-cell *matHeaderCellDef>  {{'Language.RemarksText' | translate }}
              <i-feather class="t-icon" name="more-vertical" [matMenuTriggerFor]="menu1"></i-feather>
              <mat-menu #menu1="matMenu" class="filtertrigger" xPosition="after">
                <app-filter [shortColumn]="'remarks'" [colType]="'alphabets'" 
                [labelType]="'Language.RemarksText' | translate" [isActive]="this.active"
                  (FilterColumn)="onClickOfGenericFilterButtonForRangeString($event.column, $event.formid, $event.toid,$event.label)"
                  (sortFilter)="this.onClickOfGenericColumnSort('reamrks',this.active)"></app-filter>
              </mat-menu>
            </th>
            <td mat-cell *matCellDef="let row">
              {{row.remarks}}
            </td>
          </ng-container>


          <!-- Star Column -->
          <ng-container matColumnDef="action" stickyEnd >
            <th mat-header-cell *matHeaderCellDef class="text-center">{{'Language.EditText' | translate }}</th>
            <td mat-cell *matCellDef="let row" class="text-center">
              <i-feather class="t-icon pointer" *ngIf="canEdit" name="edit-2" (click)="onClickOfGenericEditButton(row.absoluteentry)">
              </i-feather>
              <i-feather class="t-icon pointer" *ngIf="!canEdit && isActiveMenu" name="eye" (click)="onClickOfGenericEditButton(row.absoluteentry)">
              </i-feather>
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="this.getDisplayedColumnsNamesList"></tr>
          <tr mat-row *matRowDef="let row; columns: this.getDisplayedColumnsNamesList;"></tr>
        </table>
      </div>
      <mat-paginator class="mt-3" #paginator [length]="this.getRowCount" [pageSize]="this.getPaginatorPageSize"
        [pageSizeOptions]="this.getPaginatorPageSizeOptions" aria-label="Select page"
        (page)="onClickOfGenericPaginator($event)" showFirstLastButtons>
      </mat-paginator>
    </div>

  </div>


</div>